var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { resolveTestId } from '@cvent/nucleus-test-automation';
// @ts-ignore addresses build error due to nucleus-dynamic-css not having types
import { resolve } from '@cvent/nucleus-dynamic-css';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './less/Icons.All.less' or its ... Remove this comment to see the full error message
import DefaultStyles from './less/Icons.All.less';
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var _a = this.props, _b = _a.icon, icon = _b === void 0 ? '' : _b, _c = _a.modifier, modifier = _c === void 0 ? '' : _c, _d = _a.classes, classes = _d === void 0 ? {} : _d, _e = _a.iconClasses, iconClasses = _e === void 0 ? DefaultStyles : _e, fallbackText = _a.fallbackText, _f = _a.style, style = _f === void 0 ? { icon: null } : _f;
        // If Container is not provided in classes use default from iconClasses
        var containerClass = classes.container || iconClasses.container;
        // Merge default Icon classNames with modifier from imported styles //
        var iconObject = resolve({ classes: iconClasses }, icon);
        var className = classNames([iconObject.className, modifier]);
        var iconInlineStyles = style.icon ? { style: style.icon } : null;
        var ariaAttr = fallbackText
            ? { 'aria-label': fallbackText }
            : { 'aria-hidden': 'true' };
        return (_jsx("span", __assign({ className: containerClass }, resolveTestId(this.props), { children: _jsx("span", __assign({ className: className, role: "img" }, ariaAttr, iconInlineStyles), void 0) }), void 0));
    };
    Icon.propTypes = {
        /** The name of the icon to display. */
        icon: PropTypes.string.isRequired,
        /** Text used for screen reader */
        fallbackText: PropTypes.string,
        /** Modifier className to target the Icon */
        modifier: PropTypes.string,
        /** Points to LESS/CSS file to be used for icons - defaults to imported but can be changed via this prop */
        iconClasses: PropTypes.object,
        /* Class Style Object */
        classes: PropTypes.objectOf(PropTypes.string),
        /** Available Style Keys. */
        style: PropTypes.shape({
            /** Style for the icon. */
            icon: PropTypes.object
        })
    };
    return Icon;
}(React.Component));
export default Icon;
